import {h} from 'preact';
import { useRef, useEffect } from 'preact/hooks';

import * as d3 from 'd3';



export default function BarGraph(props) {
  const svgRef = useRef();

  // set the dimensions and margins of the graph
  var margin = {top: 20, right: 30, bottom: 50, left: 60},
  width = 440 - margin.left - margin.right,
  height = 350 - margin.top - margin.bottom;

  const xAggrLabelKey = props.component.meta.properties.aggregates[0].name;
  const yAggrLabelKey = props.component.meta.properties.groupings[0].name;

  const dataPoints = Object.entries(props.component.data.factMap).map( (entry, idx) => {
    // Skip the "total" entry
     if(entry[0] !== 'T!T'){
       // Return the simple value/label object. Note, only works on aggregates with one entry.
       return entry[1].aggregates[0].value;
      }
  }).filter( element => element !== undefined);

  const xAxisLabel = props.component.data.reportExtendedMetadata.aggregateColumnInfo[xAggrLabelKey].label;
  const yAxisLabel = props.component.data.reportExtendedMetadata.groupingColumnInfo[yAggrLabelKey].label;

  const xDataType = Object.values(props.component.data.reportExtendedMetadata.aggregateColumnInfo)[0].dataType;

  useEffect(() => {

    const groupsX = props.component.data.groupingsAcross.groupings;
    const groupsY = props.component.data.groupingsDown.groupings;


    var svg = d3.select(svgRef.current)
    .append("svg")
    .attr('viewBox', "0 0 " + (width + margin.left + margin.right) + " " + (height + margin.top + margin.bottom))
    .attr('preserveAspectRatio', 'xMidYMid meet')
    .append("g")
    .attr("transform",
          "translate(" + margin.left + "," + margin.top + ")");

    // X Axis
    var x = d3.scaleLinear()
    .domain([0, Math.ceil(d3.max(dataPoints))])
    .range([ 0, width]);
    svg.append("g")
    .attr("transform", "translate(0," + height + ")")
    .call(d3.axisBottom(x))
    .selectAll("text")
    .attr("transform", "translate(-10,0)rotate(-45)")
    .style("text-anchor", "end");

    // Y Axis
    var y = d3.scaleBand()
    .range([ 0, height ])
    .domain(groupsY.map(function(d) { return d.label; }))
    .padding(.1);
    svg.append("g")
    .call(d3.axisLeft(y));

    //Bars
    svg.selectAll("myRect")
    .data(dataPoints)
    .enter()
    .append("rect")
    .attr("x", x(0) )
    .attr("y", function(d, idx) { return y(groupsY[idx].label); })
    .attr("width", function(d,idx) { return x(d); })
    .attr("height", y.bandwidth() )
    .attr("fill", "#003057");

    //Axis labels
    svg.append("text")
    .attr("class", "x label")
    .attr("text-anchor", "end")
    .attr("x", "50%")
    .attr("y", height + 40)
    .text(xAxisLabel);

    svg.append("text")
    .attr("class", "y label")
    .attr("text-anchor", "end")
    .attr("y", -40)
    .attr("dy", 0)
    .attr("x", -(height / 4))
    .attr("transform", "rotate(-90)")
    .text(yAxisLabel);

    // Bar Labels
    svg.selectAll(".text")
    .data(dataPoints)
    .enter()
    .append("text")
    .attr("class","bar-label")
    .attr("x", (function(d) {
      const base = x(d);
      return base - (d.toString().length * (10 * (d / 100))) + 5;
    }))
    .attr("y", function(d, idx) { return y(groupsY[idx].label) + (y.bandwidth() / 2) + 4.5; })
    .attr("dy", "0")
    .text(function(d) {
      if (xDataType == 'percent'){
        return `${d}%`;
      }
      return d;
    })
    .attr("fill", "white");

  }, []);

  return (
    <div class={"component--type__" + props.type}>
      { props.component.meta.header &&
        <p class="container--header">{props.component.meta.header}</p>
      }
      <div class="bar-graph" ref={svgRef}></div>
      { props.component.meta.footer &&
        <p class="container--footer">{props.component.meta.footer}</p>
      }
    </div>
  );
}
